import React from "react";
import "./styles.css";
import Main from "./components/Main/Main";

export default function App() {
  return (
    <div className = {"App"}>
      <Main />
    </div>
  );
}
